import React from 'react'

export const IconEmoticonSad = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" {...props}>
    <g>
      <path
        d="M7.25001 12.8337C10.4717 12.8337 13.0833 10.222 13.0833 7.00033C13.0833 3.77866 10.4717 1.16699 7.25001 1.16699C4.02834 1.16699 1.41667 3.77866 1.41667 7.00033C1.41667 10.222 4.02834 12.8337 7.25001 12.8337Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33335 9.33366C9.33335 9.33366 8.45835 8.16699 7.00002 8.16699C5.54169 8.16699 4.66669 9.33366 4.66669 9.33366"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 5.25H5.50583"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 5.25H9.00583"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)
